<script>
    export default {
        props: {
            source: String,
            sourceMunicipalities: String,
            federations: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                municipalities: [],
                form: {
                    theme: 'theme-orange',
                    width: '',
                    latitude: '',
                    longitude: '',
                    federation: '',
                    municipality: '',
                    disabilities: false
                },
                widget: ''
            }
        },
        computed: {
            filterFederations() {
                return this.federations.filter(i => !_.isEmpty(i.name))
            }
        },
        mounted() {
            let vm = this
            $('#selectCity').select2({
                width: '100%',
                ajax: {
                    url: vm.sourceMunicipalities,
                    processResults({municipalities}) {
                        let results = []

                        vm.$set(vm, 'municipalities', municipalities)
                        municipalities.forEach(i => {
                            results.push({
                                id: i.name,
                                text: i.name
                            })
                        })

                        return {
                            results: results
                        }
                    }
                }
            });

            $('#selectCity').on('change', function(e) {
                vm.municipalities.forEach(i => {
                    if (i.name == $(this).val()) {
                        vm.$set(vm.form, 'latitude', i.latitude)
                        vm.$set(vm.form, 'longitude', i.longitude)
                        vm.$set(vm.form, 'municipality', i.name)
                        return
                    }
                })
            })
        },
        methods: {
            onGenerate() {
                let query = Object.keys(_.omit(this.form, ['width']))
                    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(this.form[k]))
                    .join('&');

                let iframe = `<iframe style="border: 1px solid #dee2e6;height:350px" scrolling="yes" src="${this.source}/?${query}" width="${this.form.width}"></iframe>`
                this.$set(this, 'widget', iframe)
            },
            onCopy() {
                window.alerts.success('Codice copiato!');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/widgets/WidgetSearchGenerationForm.vue